<template>
  <!-- Begin page content -->
  <div class="container page-content">
    <div class="row">
      <!-- left links -->
      <news-feed-navigation></news-feed-navigation>
      <!-- end left links -->
      <!-- center posts -->
      <div class="col-md-6">
        <div class="row">
          <!-- left posts-->
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <!-- post state form -->
                <post-list-input></post-list-input>
                <!-- end post state form -->
                <friend-request></friend-request>
                <!--   posts -->
                <post-list></post-list>
                <!-- end posts -->
              </div>
            </div>
          </div>
          <!-- end left posts-->
        </div>
      </div>
      <!-- end  center posts -->
      <!-- right posts -->
      <div class="col-md-3">
        <!-- Friends activity -->
        <friend-activity></friend-activity>
        <!-- End Friends activity -->

        <!-- People You May Know -->
        <friend-suggest></friend-suggest>
        <!-- End people yout may know -->
      </div>
      <!-- end right posts -->
      <div class="col-md-3">
        <friend-list @startChat="startChat"></friend-list>
      </div>
    </div>
  </div>
  <!-- end page content -->
  <friend-chat v-if="isChatOpen" @closeChat="closeChat" :isVisible="isChatOpen"></friend-chat>
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import PostList from "@/components/PostList.vue";
import FriendList from "@/components/FriendList.vue";
import FriendChat from "@/components/FriendChat.vue";
import FriendRequest from "@/components/FriendRequest.vue";
import FriendSuggest from "@/components/FriendSuggest.vue";
import FriendActivity from "@/components/FriendActivity.vue";
import NewsFeedNavigation from "@/components/NewsFeedNavigation.vue";
export default {
  components: {
    PostList,
    FriendChat,
    FriendList,
    FriendRequest,
    FriendSuggest,
    FriendActivity,
    NewsFeedNavigation,
  },
  setup() {
    const store = useStore();
    const isChatOpen = ref(false);
    function startChat(friend) {
      isChatOpen.value = true;
      store.dispatch('chat/startChat', friend);
    }
    function closeChat() {
      isChatOpen.value = false;
    }
    onMounted(async () => {
      await store.dispatch("profile/fetchProfile", {
        userId: store.getters["auth/userId"],
      });
    });
    return {
      startChat,
      closeChat,
      isChatOpen,
    };
  },
};
</script>
